<template>
  <div class="wtv-tour-details">
    <div v-for="detail in detailList" :key="detail.name" class="wtv-tour-detail"
      :class="classOfType(detail.id)">
      <div class="wtv-tour-detail-title wtv-icon">{{ detail.name }}</div>
      <div class="wtv-tour-detail-content" v-html="detail.content"></div>
    </div>
  </div>
</template>

<script>
import {
  defineComponent, computed,
} from 'vue';
import { details } from '@/functions';
import { useStore } from 'vuex';

export default defineComponent({
  name: 'Details',
  props: {
    hotelInResult: [Object, null],
  },
  setup(props) {
    const $store = useStore();
    const { tourHotel } = $store.getters;

    const hotel = props.hotelInResult || tourHotel;
    const detailList = hotel
      ? computed(() => Object.entries(hotel)
        .filter((row) => Object.prototype.hasOwnProperty.call(details, row[0]))
        .map((row) => ({
          id: row[0],
          name: details[row[0]],
          content: row[1],
        })))
      : {};
    const classOfType = (type) => `wtv-tour-detail-${type}`;

    return {
      detailList,
      classOfType,
    };
  },
  // computed: {
  //   // ...mapState(['hotel']),
  //   details() {
  //     return this.hotelInResult || this.hotel
  //       ? Object.entries(this.hotelInResult ? this.hotelInResult : this.hotel)
  //         .filter((row) => Object.prototype.hasOwnProperty.call(details, row[0]))
  //         .map((row) => ({
  //           id: row[0],
  //           name: details[row[0]],
  //           content: row[1],
  //         }))
  //       : {};
  //   },
  //   classOfType() {
  //     return (type) => `wtv-tour-detail-${type}`;
  //   },
  // },
});
</script>

<style>
.wtv-tour-detail-content ul {
  padding: 0;
  margin: 0;
  list-style-type: none;
}

.wtv-tour-detail-content ul li::before {
  content: '';
  display: inline-flex;
  width: 8px;
  height: 8px;
  border-radius: 2px;
  background-color: var(--color-bg-dark);
  margin-right: 8px;
}
</style>

<style scoped>
.wtv-tour-details {
  display: flex;
  flex-wrap: wrap;
  border-top: 1px solid var(--color-alt-5);
  border-left: 1px solid var(--color-alt-5);
}

.wtv-tour-detail {
  flex: 1 1 300px;
  border-right: 1px solid var(--color-alt-5);
  /* border-bottom: 1px solid var(--color-alt-5); */
}

.wtv-tour-detail-title {
  padding: 8px;
  background-color: var(--color-bg);
}

.wtv-tour-detail-title::before {
  margin-right: 8px;
  font-size: 18px;
  color: var(--color-alt);
}

.wtv-tour-detail-content {
  padding: 8px 36px;
}

.wtv-tour-detail-build,
.wtv-tour-detail-repair,
.wtv-tour-detail-square {
  order: -1;
}

.wtv-tour-detail-build .wtv-tour-detail-title::before {
  content: '\f6e3';
}

.wtv-tour-detail-repair .wtv-tour-detail-title::before {
  content: '\f7d9';
}

.wtv-tour-detail-square .wtv-tour-detail-title::before {
  content: '\f546';
}

.wtv-tour-detail-description .wtv-tour-detail-title::before {
  content: '\f27a';
}

.wtv-tour-detail-placement .wtv-tour-detail-title::before {
  content: '\f5a0';
}

.wtv-tour-detail-territory .wtv-tour-detail-title::before {
  content: '\f594';
}

.wtv-tour-detail-inroom .wtv-tour-detail-title::before {
  content: '\f52b';
}

.wtv-tour-detail-services .wtv-tour-detail-title::before {
  content: '\f562';
}

.wtv-tour-detail-servicepay .wtv-tour-detail-title::before {
  content: '\f4c0';
}

.wtv-tour-detail-servicefree .wtv-tour-detail-title::before {
  content: '\f4bd';
}

.wtv-tour-detail-animation .wtv-tour-detail-title::before {
  content: '\f59a';
}

.wtv-tour-detail-child .wtv-tour-detail-title::before {
  content: '\f1ae';
}

.wtv-tour-detail-beach .wtv-tour-detail-title::before {
  content: '\f5ca';
}

.wtv-tour-detail-meallist .wtv-tour-detail-title::before {
  content: '\f725';
}</style>
